import React, { memo } from 'react';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import { shouldScrollInToView } from '@components/directUser/utils';
import LifeCycleModule from './lifeCycle.module';

function getAnchorIdFromProp(props) {
  return props.identifier;
}

export default CommentAnchor(LifeCycleModule, {
  shouldScrollInToView,
  getAnchorIdFromProp,
});
